import React from 'react';
import { Paper, Box, Divider, Slide } from '@mui/material';
import ChatHeader from './ChatHeader';
import LoadingState from './LoadingState';
import UserInfoForm from './UserInfoForm';
import StartChatButton from './StartChatButton';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';

const ChatWindow = ({
  isOpen,
  isMinimized,
  isInitializing,
  isUserInfoSubmitted,
  currentSession,
  messages,
  isTyping,
  showScrollToBottom,
  isSubmittingMessage,
  connectionState,
  isLoggedIn,
  loggedInUserName,
  loggedInUserEmail,
  userInfoMethods,
  messageMethods,
  initializeChatSessionMutation,
  sendMessageMutation,
  onMinimize,
  onClose,
  onUserInfoSubmit,
  onStartChatForLoggedInUser,
  onSendMessage,
  onKeyPress,
  onScroll,
  onScrollToBottom,
}) => {
  if (!isOpen) return null;

  return (
    <Slide direction="up" in={isOpen} timeout={300}>
      <Paper 
        className={`chat-window ${isMinimized ? 'minimized' : ''}`}
        sx={{
          position: 'fixed',
          bottom: { xs: 0, sm: '28px' },
          right: { xs: 0, sm: '24px' },
          width: { xs: '100%', sm: '340px' },
          height: { xs: '100vh', sm: '500px' },
          maxHeight: { xs: '100vh', sm: 'calc(100vh - 140px)' },
          zIndex: 9999,
        }}
      >
        {/* Chat Header */}
        <ChatHeader
          isUserInfoSubmitted={isUserInfoSubmitted}
          connectionState={connectionState}
          onMinimize={onMinimize}
          onClose={onClose}
        />

        {!isMinimized && (
          <>
            <Divider />
            
            {/* Chat Content */}
            <Box className="chat-content">
              {isInitializing ? (
                <LoadingState />
              ) : !isUserInfoSubmitted ? (
                isLoggedIn ? (
                  <StartChatButton
                    userName={loggedInUserName}
                    userEmail={loggedInUserEmail}
                    isPending={initializeChatSessionMutation.isPending}
                    onStartChat={onStartChatForLoggedInUser}
                  />
                ) : (
                  <UserInfoForm
                    formMethods={userInfoMethods}
                    isPending={initializeChatSessionMutation.isPending}
                    onSubmit={onUserInfoSubmit}
                  />
                )
              ) : (
                <ChatMessages
                  messages={messages}
                  isTyping={isTyping}
                  showScrollToBottom={showScrollToBottom}
                  onScroll={onScroll}
                  onScrollToBottom={onScrollToBottom}
                />
              )}
            </Box>

            {isUserInfoSubmitted && (
              <>
                <Divider />
                <ChatInput
                  formMethods={messageMethods}
                  isPending={sendMessageMutation.isPending || isSubmittingMessage}
                  onSubmit={onSendMessage}
                  onKeyPress={onKeyPress}
                />
              </>
            )}
          </>
        )}
      </Paper>
    </Slide>
  );
};

export default ChatWindow;
